module.exports = __webpack_public_path__ + "img/pay_size_sel11.60238c95.png";